export default function (videoNumber, videoNumberOpts) {
  const widgetName = videoNumber;
  const widgetOpts = videoNumberOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (data, owl, hasData) {
      if (hasData) {
        const widgetData = data.items[0];
        const videoId = widgetData.Description;
        const iframeStructure = `
                <iframe id="video-target" width="602" height="339" src="https://www.youtube.com/embed/${videoId}?" 
                  title="YouTube video player" frameborder="0" 
                  allow="accelerometer; 
                  autoplay; 
                  clipboard-write; 
                  encrypted-media; 
                  gyroscope; 
                  picture-in-picture; 
                  web-share" 
                  referrerpolicy="strict-origin-when-cross-origin" 
                  loading="lazy"
                  allowfullscreen>
                </iframe>`;
        $(`#${widgetName}`).empty();
        $(`#${widgetName}`).append(iframeStructure);
      } else {
        $(`#${widgetName}`).remove();
      }
    },
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    showDescription: true,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    buyNowButton: false,
    moreButton: false,
    scriptPath: widgetOpts.scriptPath,
  });
}
